import {
  selectBoardMenuData,
  selectIsBoardMenuLoading,
} from "app/redux/selector";
import { IBoardMenu } from "app/types";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useContainerWidth } from "../../helpers";
import AddBoard from "../AddBoard";
import { calculateBoardVisibility } from "./helper";
import Home from "./home";
import Loading from "./loading";
import LotOfBoardsButton from "./LotofBoardButton";
import VisibleBoards from "./VisibleBoards";

const ESTIMATED_ITEM_WIDTHS = {
  home: 200,
  board: 160,
  addBoard: 120,
  more: 100,
  padding: 20,
};

const Index: React.FC = () => {
  const isLoading = useSelector(selectIsBoardMenuLoading);
  const boardData = useSelector(selectBoardMenuData);
  const { boardId } = useParams<{ boardId?: string }>();
  const [options, setOptions] = useState<IBoardMenu[]>(boardData || []);
  const [selectedBoardId, setSelectedBoardId] = useState<string | null>(null);
  const { containerWidth, containerRef } = useContainerWidth();

  useEffect(() => {
    if (boardId) setSelectedBoardId(boardId);
  }, [boardId]);

  useEffect(() => {
    if (boardData) {
      setOptions(
        [...boardData].sort((a, b) => (a.order ?? 0) - (b.order ?? 0)),
      );
    }
  }, [boardData]);

  const { visibleBoards, hiddenBoards } = useMemo(
    () =>
      calculateBoardVisibility(options, containerWidth, ESTIMATED_ITEM_WIDTHS),
    [containerWidth, options],
  );

  const renderContent = () => {
    return (
      <div
        ref={containerRef}
        className="flex flex-nowrap h-[42px] overflow-hidden rounded-sm"
      >
        <Home selectedBoardId={selectedBoardId} />
        <VisibleBoards data={visibleBoards} selectedBoardId={selectedBoardId} />
        <LotOfBoardsButton hiddenBoards={hiddenBoards} />
        <div className="flex items-center px-3 py-2 hover:bg-gray-100 flex-shrink-0 h-full">
          <AddBoard
            visibleBoard={visibleBoards?.length}
            hiddenBoard={hiddenBoards?.length}
          />
        </div>
      </div>
    );
  };
  return isLoading ? <Loading /> : renderContent();
};

export default Index;
